import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'connections-search',
  templateUrl: './connections-search.component.html',
  styleUrls: ['./connections-search.component.scss']
})
export class ConnectionsSearchComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConnectionsSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public search: any) { }

  onApply = new EventEmitter();

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();
    this.onApply.emit(this.search);
  }
}
